import React from "react";

let createReactClass = require("create-react-class");

import runPropActions from "Utils/runPropActions";

/*
 * config for the baselayer map without any labels
 * */
const baseLayer = () =>
  "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png?key=cb1_316p_1_74e76ecaa949d2c56ccb77f0".chain(
    tileUrl =>
      L.tileLayer(tileUrl, {
        attribution: attribution,
        opacity: 0.9,
        zIndex: 0
      })
  );

/*
 * config for the labels of the baselayer (
 * */
const baseLayerLabels = () =>
  "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_only_labels/{z}/{x}/{y}.png?key=cb1_316p_1_74e76ecaa949d2c56ccb77f0".chain(
    tileUrl =>
      L.tileLayer(tileUrl, {
        attribution: attribution,
        opacity: 0.9,
        zIndex: 10
      })
  );

/*
 * The attribution to be shown at the bottom of the map
 * */
const attribution =
  '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, © <a href="https://carto.com/attribution">CARTO</a>';

const Map = createReactClass({
  render() {
    let enhancedChildren = null;
    if (React.Children.count(this.props.children) > 0 && this.state.map) {
      enhancedChildren = React.Children.map(this.props.children, child =>
        child ? React.cloneElement(child, { map: this.state.map }) : null
      );
    }
    return <div id="_map">{enhancedChildren}</div>;
  },
  getInitialState() {
    return {
      map: null
    };
  },
  propActions() {
    return {
      boundaries: {
        enter: "fitBounds",
        change: "fitBounds"
      }
    };
  },
  fitBounds({ boundaries }) {
    this.map && this.map.fitBounds(boundaries);
  },
  componentWillMount() {
    this.runPropActions = runPropActions.bind(this);
    this.runPropActions({}, this.props, this.propActions());
  },
  componentDidMount() {
    // Setup map with
    // basic tile layers
    this.map = new L.Map("_map", {
      zoomControl: false,
      // TODO: make center a config option
      center: [140, -22.594].reverse(),
      zoom: 6,
      maxBounds: this.props.maxBounds,
      minZoom: 5,
      maxZoom: 16,
      layers: [baseLayer(), baseLayerLabels()]
    });
    // add zoom controlls
    L.control
      .zoom({
        position: "topleft"
      })
      .addTo(this.map);
    this.runPropActions({}, this.props, this.propActions());
    this.setState({ map: this.map });
  },
  componentWillUnmount() {
    this.map.remove();
  },
  componentWillReceiveProps(newProps) {
    this.runPropActions(this.props, newProps, this.propActions());
    if (newProps.visible && !this.props.visible)
      setTimeout(() => this.map.invalidateSize(true), 500);
  }
});

export default Map;



// WEBPACK FOOTER //
// ./components/Map/Map.js